// @flow
// QA & Compliance dashboard.
import { useState } from 'react';
import { Box, Tab as MuiTab, Tabs } from '@mui/material';
import { isAgentManager, ListPageWrapper, PageTitle } from '../../shared';
import { MyScorecard } from './tabs/my-scorecard';
import { TeamOverview } from './tabs/team-overview';
import { Compare } from './tabs/compare';
import { QuestionPerformance } from './tabs/question-performance';
import { Audits } from './tabs/audits';
import { ByClient } from './tabs/by-client';
import { withCallDrawer } from './ui/call-drawer-by-aircall';

const Page = () => {
  const isManager = isAgentManager();
  const [tab, setTab] = useState(0);
  // Selected agent for My Scorecard; set when a row is clicked in Team Overview.
  const [selectedAgentId, setSelectedAgentId] = useState<string | undefined>(undefined);

  return (
    <ListPageWrapper sx={{ overflow: 'hidden' }}>
      {/* Header + tabs stay fixed; only the tab content below scrolls.
          Per-tab controls (agent picker on My Scorecard, filters on Audits) live in
          their own tabs since they only make sense there. */}
      <PageTitle title={'QA & Compliance'} />

      <Tabs value={tab} onChange={(_, v) => setTab(v)} variant={'scrollable'} scrollButtons={'auto'}
            sx={{ flexShrink: 0, '& .MuiTab-root': { textTransform: 'none' } }}>
        <MuiTab label={'My Scorecard'} />
        {isManager && <MuiTab label={'Team Overview'} />}
        {isManager && <MuiTab label={'Compare'} />}
        {isManager && <MuiTab label={'Question Performance'} />}
        {isManager && <MuiTab label={'Audits'} />}
        {isManager && <MuiTab label={'By Client'} />}
      </Tabs>

      <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', pt: 2 }}>
        {tab === 0 && <MyScorecard agentId={selectedAgentId} onAgentChange={setSelectedAgentId} />}
        {isManager && tab === 1 && (
          <TeamOverview onSelectAgent={id => { setSelectedAgentId(id); setTab(0); }} />
        )}
        {isManager && tab === 2 && <Compare />}
        {isManager && tab === 3 && <QuestionPerformance />}
        {isManager && tab === 4 && <Audits />}
        {isManager && tab === 5 && <ByClient />}
      </Box>
    </ListPageWrapper>
  );
};

export const Qa = withCallDrawer(Page);